export default __webpack_public_path__ + "static/media/BusTravelingActive.0793ba38.svg";